import { createContext, useContext } from 'react';
import type { ShellResolution } from './detect';

export const ShellContext = createContext<ShellResolution>({ shell: 'admin', basename: '/admin', mode: 'path' });

/** Current shell (always `admin`) and router basename. */
export function useShell(): ShellResolution {
  return useContext(ShellContext);
}
